//@author: travis
import { S25Util } from "../util/s25-util";
import { DataAccess } from "../dataaccess/data.access";

export interface SequenceSet {
    kind: "event" | "profile" | "reservation";
    updated: string;
    idSet: { row_num: number; rsrvId: number; eventId: number; profileId: number }[];
}

export class SequenceService {
    public static getSequenceId(sequenceName: "events" | "date_profile") {
        return DataAccess.get(
            DataAccess.injectCaller(
                "/sequence/id.json?itemName=" + sequenceName + "&rand=" + S25Util.generateQuickGUID(),
                "SequenceService.getSequenceId",
            ),
        ).then(
            function (data) {
                const sequenceId = S25Util.propertyGet(data, "sequence_id");
                return sequenceId && parseInt(sequenceId);
            },
            function (error): null {
                return null;
            },
        );
    }

    public static async getSequenceIds(
        sequenceName: "event" | "profile" | "reservation",
        quantity: number,
    ): Promise<SequenceSet[]> {
        const url = DataAccess.params({
            element: sequenceName,
            quantity: quantity || 1,
        });
        const resp = await DataAccess.post(
            DataAccess.injectCaller(`/micro/sequence/generate.json?${url}`, "SequenceService.getSequenceIds"),
        );

        return S25Util.array.forceArray<SequenceSet>(resp?.content?.data?.items).map((item) => ({
            kind: sequenceName,
            updated: item.updated,
            idSet: item.idSet,
        }));
    }
}
